/** Parse a possibly-localized number string ("1.250,50" or "1,250.50" or "1250"). */
export function parseLocalizedNumber(value: unknown): number | null {
  if (value == null || value === "") return null;
  if (typeof value === "number") return isNaN(value) ? null : value;
  if (typeof value === "object") {
    const obj = value as Record<string, unknown>;
    const keys = [
      "value",
      "answer",
      "formattedValue",
      "formatted_value",
      "amount",
      "number",
    ];
    for (const k of keys) {
      if (obj[k] != null) {
        const p = parseLocalizedNumber(obj[k]);
        if (p != null) return p;
      }
    }
    return null;
  }
  const text = String(value)
    .trim()
    .replace(/\s/g, "")
    .replace(/€/g, "")
    .replace(/[^\d,.\-]/g, "");
  if (!text) return null;
  const lc = text.lastIndexOf(",");
  const ld = text.lastIndexOf(".");
  let normalized = text;
  if (lc !== -1 && ld !== -1) {
    const dec = lc > ld ? "," : ".";
    const thou = dec === "," ? "." : ",";
    normalized = normalized.split(thou).join("").replace(dec, ".");
  } else if (lc !== -1) {
    const parts = text.split(",");
    if (parts.length === 2 && parts[1]!.length === 3) {
      normalized = text.replace(",", "");
    } else {
      normalized = text.replace(",", ".");
    }
  }
  const num = Number(normalized);
  return isNaN(num) ? null : num;
}
